import React from "react";

const Footer = () => {
    return (
        <div className="footer">
            
                <p>
                    Created and designed by{" "}
                    <a
                        href="https://github.com/sophiasagan"
                        target="_blank"
                        className="link"
                        rel="noopener noreferrer"
                    >
                        Sophia Jung
                    </a>{" "}
                </p>
            
            
        </div>
    );
};

export default Footer;